import React, { useEffect, useState } from "react";
import "../Main.css";
import { Modal } from "react-bootstrap";
import { Button } from "@mui/material";
import { HOST_URL } from "../common";

const AdminScreen = (location) => {
  const [reportDate, setReportDate] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [currentLookupReport, setCurrentLookupReport] = useState([]);

  useEffect(() => {
    fetch(HOST_URL + ":3002/api", {
      method: "GET",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.code === "error") {
          window.location.href = "/login";
        } else {
          if (Number(result.user[0].level) === 2) {
            window.location.href = "/";
          }
        }
      });
    let href = window.location.href;
    const date = href.substr(href.indexOf("date") + 5, href.length);

    setReportDate(date);
  }, []);

  const fetchReportByReportDate = (id, name) => {
    //const url = 'http://30.30.30.3:3002/report?cmd=lookup&UserID=' + id + '&date=' + reportDate;
    const url =
      HOST_URL + ":3002/report?cmd=lookup&UserID=" + id + "&date=" + reportDate;
    console.log(url);

    fetch(url, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((result) => {
        result.report.name = name;
        setCurrentLookupReport(result.report);
        setModalShow(true);
        console.log(result.report);
      });
  };

  const modalClose = () => {
    setModalShow(false);
  };

  const writeFormattedReport = () => {
    if (currentLookupReport.length < 1) {
      return <div></div>;
    } else {
      let tags = "";
      // tags += "<h5>금일 진행 업무</h5> <hr/>" + "<ul>";
      tags = `${tags}<h5>금일 진행 업무</h5><hr/><ul>`;

      currentLookupReport.todayissue.map((value, index) => {
        return (tags += value[index + 1].replace(/\n/gi, "<br/>") + "<br/>");
      });
      // tags += "</ul>" + "<h5>진행 예정 업무</h5> <hr/>" + "<ul>";
      tags = `${tags}</ul><h5>진행 예정 업무</h5><hr/><ul>`;
      currentLookupReport.nextdayissue.map((value, index) => {
        return (tags += value[index + 1].replace(/\n/gi, "<br/>") + "<br/>");
      });
      // tags += "</ul>" + "<h5>기타 및 부서별 협조사항</h5> <hr/>" + "<ul>";
      tags = `${tags}</ul><h5>기타 및 부서별 협조사항</h5><hr/><ul>`;
      currentLookupReport.etcissue.map((value, index) => {
        return (tags += value[index + 1].replace(/\n/gi, "<br/>") + "<br/>");
      });
      // tags += "</ul>";
      tags = `${tags}</ul>`;

      console.log(tags);

      return <div dangerouslySetInnerHTML={{ __html: tags }}></div>;
    }
  };

  // 회원 데이터 전부 가져오기
  const [members, setMembers] = useState([]);

  const getMembers = async () => {
    const url = HOST_URL + ":3002/getMember";
    const res = await fetch(url, {
      method: "GET",
      credentials: "include",
    });
    const data = await res.json();
    setMembers(Object.entries(data));
  };
  useEffect(() => {
    getMembers();
  }, []);

  return (
    <div className="Main-container">
      <Modal size="lg" show={modalShow} onHide={modalClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            일일업무보고 ({currentLookupReport.name} :{" "}
            {currentLookupReport.createdAt})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{writeFormattedReport()}</Modal.Body>
        <Modal.Footer>
          <Button
            variant="contained"
            style={{ margin: 10 }}
            onClick={modalClose}
          >
            닫기
          </Button>
        </Modal.Footer>
      </Modal>
      <div
        style={{
          borderStyle: "dashed",
          borderWidth: 1,
          padding: 50,
          marginTop: "20px",
        }}
      >
        <div style={{ paddingBottom: 20 }}>
          <h3>{reportDate}</h3>
        </div>
        <h3>연구소</h3>
        <ul style={{ textDecorationLine: "underline", cursor: "pointer" }}>
          {members.map((member) => {
            return member[1].department === "한국공간정보연구소" ? (
              <li
                key={member[1].id}
                onClick={() =>
                  fetchReportByReportDate(
                    member[1].id,
                    member[1].name + " " + member[1].position
                  )
                }
              >
                {member[1].name + " (" + member[1].position + ")"}
              </li>
            ) : null;
          })}
        </ul>

        <h3>사업본부</h3>
        <ul style={{ textDecorationLine: "underline", cursor: "pointer" }}>
          {members.map((member) => {
            return member[1].department === "콘텐츠사업부" ? (
              <li
                key={member[1].id}
                onClick={() =>
                  fetchReportByReportDate(
                    member[1].id,
                    member[1].name + " " + member[1].position
                  )
                }
              >
                {member[1].name + " (" + member[1].position + ")"}
              </li>
            ) : null;
          })}
        </ul>
      </div>
      <Button
        variant="contained"
        style={{ margin: 10 }}
        onClick={() => window.history.back()}
      >
        뒤로
      </Button>
    </div>
  );
};

export default AdminScreen;
